<template>
  <div class="botm-bar-wrap">
    <offer-applied-message
      v-if="welcomeOffers?.length > 0"
    ></offer-applied-message>
    <div
      class="bottom-nav active"
      :class="{ 'with-checkout': cartQuantity > 0 }"
      :falseProp="shouldEdvVisible"
      :style="{
        background: modulePropsData?.tabBackgroundColor,
      }"
    >
      <span
        v-for="(item, index) in dataToShow"
        :class="[
          (isRequiredItem(item, 'cart') && cartQuantity == 0) ||
          !shouldTabVisible(item)
            ? ''
            : 'nav-item',
        ]"
      >
        <template v-if="isRequiredItem(item, 'edv')">
          <template v-if="isConfigStatic">
            <span
              class="shimmer-container"
              style="height: 20px; width: 100px"
            ></span>
          </template>
          <template v-else>
            <div
              class="nav-item-content"
              :style="{
                color: item?.text_color,
                background: item?.background_color,
              }"
              @click="goto(item, index)"
            >
              <span class="nav-item-text">{{ item.title }}</span>
              <template v-if="item?.flag">
                <i
                  aria-hidden="true"
                  :class="item?.html"
                  v-if="flagForEdvStaticCase"
                ></i>
                <i aria-hidden="true" class="jfi-bb-offers" v-else></i>
              </template>

              <lazy-image
                alt="nav item image"
                :src="item.icon + Utility.getSitePropsVersion()"
                :src-placeholder="getPlaceHolderImg"
                v-else
              />
            </div>
          </template>
        </template>
        <template v-else-if="isRequiredItem(item, 'cart')">
          <div
            @click="goto(item, index)"
            class="nav-item-content"
            :style="{
              color: item?.text_color,
              background: item?.background_color,
            }"
            v-if="cartQuantity !== 0"
          >
            <span class="nav-item-text">{{ item.title }}</span>
            <span class="pr">
              <lazy-image
                alt="nav item image"
                :src="item.icon + Utility.getSitePropsVersion()"
                :src-placeholder="getPlaceHolderImg"
              />
              <transition name="slide-fade" mode="out-in">
                <span class="count-holder1" :key="cartQuantity">{{
                  cartQuantity
                }}</span>
              </transition>
            </span>
          </div>
        </template>
        <template v-else>
          <div
            @click="goto(item, index)"
            class="nav-item-content"
            :style="{
              color: item?.text_color,
              background: item?.background_color,
            }"
            v-if="shouldTabVisible(item)"
          >
            <span class="nav-item-text">{{ item.title }}</span>
            <template v-if="item?.flag">
              <i aria-hidden="true" :class="item?.html"></i>
            </template>
            <lazy-image
              alt="nav item image"
              :src="item.icon + Utility.getSitePropsVersion()"
              :src-placeholder="getPlaceHolderImg"
              v-else
            />
          </div>
        </template>
      </span>

      <span v-if="isCheckoutVisibleFromLocal" class="nav-item cart-nav">
        <div
          v-if="cartQuantity >= 0"
          class="btn btn-checkout disp-col-inline"
          :style="{
            background: modulePropsData?.checkoutBackgroundColor,
            borderColor: modulePropsData?.checkoutBackgroundColor,
            color: modulePropsData?.checkoutTextColor,
          }"
          @click="
            goto(
              {
                actionToPerform: {
                  action: 'cart',
                },
              },
              index
            )
          "
        >
          <span class="cart-total">
            <i aria-hidden="true" class="jfi-cart fs-18"></i>
            <transition name="slide-fade" mode="out-in">
              <span class="count-holder" :key="cartQuantity">{{
                cartQuantity
              }}</span>
            </transition>
          </span>
          <span class="ml10 tl">
            <span class="block fs-11" v-if="!hideCartTotal"
              ><span class="rs">Rs.</span>
              <span> {{ cartTotal }} + taxes </span>
            </span>
            <span
              class="block fs-14 bold"
              :class="[hideCartTotal ? 'mt6 mb6' : '']"
              v-html="checkoutTitle"
            ></span>
          </span>
          <i aria-hidden="true" class="jfi-arrow-line fs-16"></i>
        </div>
      </span>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import { defineAsyncComponent } from "vue";
import { keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import {
  projectBasePathWithFolder,
  v2PwaBasePath,
} from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import userActivityTracking from "../helpers/UserActivityTracking";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import { keyMapsMutation } from "../helpers/storeKeys";
import localStorageFunc from "../helpers/localStorageFunc";
import { imgBaseUrl, staticImgBaseUrl } from "../config/apiEndpoints";
import BottomTabsFallbackData from "../assets/FallbackData/BottomTabs.json";

export default {
  name: "BottomBarV2",
  props: ["moduleProps", "dataResults"],
  components: {
    OfferAppliedMessage: defineAsyncComponent(() =>
      import("./OfferAppliedMessage.vue")
    ),
  },
  data() {
    return {
      showMenuModal: false,
      modulePropsData: {},
      data: [],
      dataToShow: [],
      maxTabs: 3,
      flagForLocal: false,
      flagForEdvStaticCase: "",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.data =
      typeof this.dataResults != null &&
      typeof this.dataResults != "null" &&
      typeof this.dataResults != "undefined"
        ? JSON.parse(this.dataResults)
        : [];

    if (!this.data?.length) {
      this.data = BottomTabsFallbackData;
      this.flagForLocal = true;
    }
    this.data = this.data?.map((item) => {
      let temp = item;
      if (item?.mobile_action) {
        temp.actionToPerform = JSON.parse(item?.mobile_action)[0] || {};
      }
      return temp;
    });

    this.maxTabs = Number(this.modulePropsData?.maxTabs) || 4;
    if (this.isCheckoutVisibleFromLocal) {
      this.maxTabs = this.maxTabs - 1;
    }
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}, eventName = "") {
      let eventType = isClicked ? "Click" : "Impression";
      if (eventName) {
        eventType = eventName;
      }
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = { ...eObj };
      let sectionPosition = preEventObj["sectionPosition"];
      delete preEventObj["sectionPosition"];
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["screenName"] == PageNames.NEXTGEN_SEARCHPAGE
          ? "search"
          : preEventObj["sectionName"]
          ? preEventObj["sectionName"]
          : "bottom menu",
        sectionPosition,
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    handleCartClick(event, item) {
      //Amplitude click event load
      LocalStorageFunc.setTrackerOfKeyInSession(true);
      this.eventFunction(true, { category: "view cart" });
      userActivityTracking.checkout(0);
      window.location.href = `${v2PwaBasePath}/cart`;
    },
    modifyArrayWrtStore(array = [], maxTabs) {
      if (array.length == 0) {
        return;
      }
      const storeId = localStorageFunc.storeId();
      let finalArray = array.slice(0, maxTabs);
      let result = [];

      for (let entry of finalArray) {
        if (!entry?.store_id) {
          result.push(entry);
        } else {
          let storeIDs = entry.store_id.split(",");
          if (!storeIDs.includes(storeId)) {
            let alternateId = entry["alternate_tab_id"];
            let alternateEntry = array.find((item) => item.id === alternateId);
            if (alternateEntry) {
              result.push(alternateEntry);
            } else {
              result.push(entry);
            }
          } else {
            result.push(entry);
          }
        }
      }

      return result.slice(0, maxTabs);
    },
    scrollOrRedirectCategory(data) {
      const links = [data.actionToPerform];
      let action = links[0]?.action;

      if (this.isSeparateMenuVariant) {
        let url =
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        if (
          action === "menu" ||
          action === "MENU_LIST" ||
          action === "PRODUCT_LIST"
        ) {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", links[0].href);
          window.location.href = url;
        } else if (action === "edv") {
          const hrefIs = links[0]?.href;
          window.location.href = Utility.getEdvPageUrl(hrefIs);
        } else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${links[0]?.href}`;
        } else {
          // window.location.href = `${v2PwaBasePath}/menu`;
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
          window.location.href = url;
        }
        return;
      }

      let currentElem = this.currentElementIdInStore.map((i) => i.categoryId);
      let curElementId = currentElem.includes(Number(links[0].href));
      if (curElementId) {
        let scrollTopMargin = 70; //default
        if (this.isAnchorLinkVariant) {
          scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
        }
        switch (action) {
          case "menu":
            Utility.scrollUptoTo(
              "element_catg_" + links[0].href,
              scrollTopMargin
            );
            break;
          case "MENU_LIST":
            Utility.scrollUptoTo(
              "element_catg_" + links[0].href,
              scrollTopMargin
            );
            break;
          case "PRODUCT_LIST":
            Utility.scrollUptoTo(
              "element_catg_" + links[0].href,
              scrollTopMargin
            );
            break;
          default: // set the default scroll to home
            Utility.scrollUptoMenuTop();
            break;
        }
      } else {
        if (action === "edv") {
          const hrefIs = links[0]?.href;
          window.location.href = Utility.getEdvPageUrl(hrefIs);
        } else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${links[0]?.href}`;
        } else {
          Utility.scrollUptoMenuTop();
        }
      }
    },
    goto(item, index) {
      const action = item?.actionToPerform?.action || "";
      let evenObj = {};
      if (action.toLowerCase() === "cart") {
        this.handleCartClick();
        return;
      } else if (action.toLowerCase() === "edv") {
        evenObj = { category: "1 + 1 Offer" };
      } else if (action.toLowerCase() === "offers") {
        evenObj = { category: "deals & offers" };
      } else {
        evenObj = { category: item.title.toLowerCase() || "menu" };
      }
      this.eventFunction(true, evenObj);
      this.scrollOrRedirectCategory(item);
    },
    isRequiredItem(item, key = "", array = false) {
      if (array) {
        return !["edv", "cart"].includes(
          item?.actionToPerform?.action.toLowerCase()
        );
      }
      return item?.actionToPerform?.action.toLowerCase() == key;
    },
    removeDuplicates(arr) {
      const map = new Map();
      arr?.forEach((item) => {
        map.set(item.id, item);
      });
      return Array.from(map.values());
    },
    shouldTabVisible(item) {
      if (!item.flag) {
        return true;
      } else {
        if (item?.title == "Offers" && this.flagForEdvStaticCase) {
          return false;
        }
        return true;
      }
    },
  },
  computed: {
    cartQuantity() {
      let _ = this.$store.getters[keyMapsGetter.CART_QUANTITY];
      let initialCartUpdatedByUserActionRef =
        this.$store.state.Cart.initialCartUpdatedByUserActionRef;
      if (initialCartUpdatedByUserActionRef.type == "NONE") {
        return _;
      }

      let preEventObj = {
        eventCategory: "ecommerce",
        eventAction:
          initialCartUpdatedByUserActionRef.type == "REMOVE"
            ? "remove from cart"
            : "add to cart",
        addToCartQuantity:
          initialCartUpdatedByUserActionRef.type == "REMOVE" ? -1 : 1,
        itemName: initialCartUpdatedByUserActionRef.item?.name?.toLowerCase(),
        price: initialCartUpdatedByUserActionRef.item?.itemPrice,
        itemSku: initialCartUpdatedByUserActionRef.item?.id,
        isIrctcOrder: "no",
        size: initialCartUpdatedByUserActionRef.item?.sizeName?.toLowerCase(),
        crust: initialCartUpdatedByUserActionRef.item?.crustName?.toLowerCase(),
        ecomCategory:
          initialCartUpdatedByUserActionRef.item?.name?.toLowerCase(),
        positionWithinSection:
          initialCartUpdatedByUserActionRef.positionWithinSection,
        mealOriginalPrice: initialCartUpdatedByUserActionRef?.mealOriginalPrice,
        mealFinalPrice: initialCartUpdatedByUserActionRef?.mealFinalPrice,
        mealSavings: initialCartUpdatedByUserActionRef?.mealSavings,
      };

      if (initialCartUpdatedByUserActionRef.source == "searchModal") {
        if (
          initialCartUpdatedByUserActionRef.subSource ==
          "nonCustomizableCardAdd"
        ) {
          preEventObj["screenName"] =
            PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
        } else if (
          initialCartUpdatedByUserActionRef.subSource == "customisation"
        ) {
          preEventObj["screenName"] =
            PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
        } else {
          preEventObj["screenName"] = PageNames.NEXTGEN_SEARCHPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        }
      } else {
        if (
          initialCartUpdatedByUserActionRef.subSource ==
          "nonCustomizableCardAdd"
        ) {
          preEventObj["screenName"] = PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        } else if (
          initialCartUpdatedByUserActionRef.subSource == "customisation"
        ) {
          preEventObj["screenName"] = PageNames.NEXTGEN_CUSTOISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        }
      }

      preEventObj["sectionPosition"] =
        initialCartUpdatedByUserActionRef.sectionPosition;

      if (initialCartUpdatedByUserActionRef.sectionName) {
        preEventObj["sectionName"] =
          initialCartUpdatedByUserActionRef.sectionName;
      }

      this.eventFunction(
        true,
        preEventObj,
        initialCartUpdatedByUserActionRef.type == "REMOVE"
          ? "removeFromCart"
          : "addToCart"
      );
      return _;
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    paymentOffers() {
      return this.$store.state.PaymentOffers.paymentOffers;
    },
    checkoutTitle() {
      return this.modulePropsData?.checkoutLabel;
    },
    hideCartTotal() {
      return true;
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        Utility.getLinkRewriteFromSiteprops() ===
          PageNames.NEXTGEN_LINKREWRITE_HOME ||
        Utility.getLinkRewriteFromSiteprops() ===
          PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
      ) {
        return true;
      } else {
        return false;
      }
    },
    isConfigStatic() {
      return this.$store.state.Config.isStatic;
    },
    shouldEdvVisible() {
      let edvInStore = this.$store.state.Location.storeDetails?.edvEnable;
      if (edvInStore !== undefined && edvInStore) {
        this.dataToShow = this.removeDuplicates(
          this.modifyArrayWrtStore(this.data, this.maxTabs)
        );
        this.flagForEdvStaticCase = true;
        return edvInStore;
      } else {
        const temp = this.modifyArrayWrtStore(this.data, this.maxTabs);
        let finalResult = temp?.map((item) => {
          if (item.actionToPerform.action === "edv") {
            let replacement = this.data.find((replacementItem) => {
              return replacementItem.id === item["alternate_tab_id"];
            });

            return replacement || item;
          }
          return item;
        });

        this.dataToShow = this.removeDuplicates(finalResult);
        this.flagForEdvStaticCase = false;
        return false;
      }
    },
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
    isCheckoutVisibleFromLocal() {
      return (
        this.modulePropsData?.isCheckoutVisible === "true" || this.flagForLocal
      );
    },
  },
};
</script>
